import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Check, X } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | ok | error

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.get("/subscribers/unsubscribe", { params: { token } })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div data-testid="unsubscribe-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      {status === "loading" && <div className="text-muted_ink">Updating preferences…</div>}
      {status === "ok" && (
        <>
          <Check className="w-16 h-16 mx-auto text-terracotta" strokeWidth={1.25} />
          <h1 className="font-serif text-5xl mt-8">You've been unsubscribed.</h1>
          <p className="text-muted_ink mt-4">No more emails from Folio. Sorry to see you go.</p>
          <Link to="/" className="btn-secondary mt-10 inline-flex">Back to home</Link>
        </>
      )}
      {status === "error" && (
        <>
          <X className="w-16 h-16 mx-auto text-muted_ink" strokeWidth={1} />
          <h1 className="font-serif text-5xl mt-8">That link didn't work.</h1>
          <p className="text-muted_ink mt-4">The link may be invalid or already used.</p>
          <Link to="/" className="btn-secondary mt-10 inline-flex">Back to home</Link>
        </>
      )}
    </div>
  );
}
